import { NgModule } from '@angular/core';
import { FormatMailboxTypesPipe } from './format-mailbox-types.pipe';

@NgModule({
   declarations: [FormatMailboxTypesPipe],
   exports: [FormatMailboxTypesPipe],
})
export class FormatMailboxTypesPipeModule {}
